import { Member } from "@/company/members/types";
import { City } from "../../dashboard-filters/components/location-filters/city-input/types";
import { Space } from "../../dashboard-filters/components/location-filters/space-input/types";

export const productCompetencyKeys = {
  all: ["product-competency"] as const,
  list: (params: {
    startDate?: string | Date | null;
    endDate?: string | Date | null;
    city?: City[] | null;
    group_id?: number | null;
    type?: string[] | null;
    status?: number[] | null;
    users?: Member[] | null;
    spaces?: Space[] | null;
  }) => {
    const toKey = (v: string | Date | undefined | null) => {
      if (!v) return null;
      if (typeof v === "string") return v;
      const t = v.getTime?.();
      return Number.isFinite(t) ? v.toISOString().split("T")[0] : null;
    };

    return [
      ...productCompetencyKeys.all,
      {
        startDate: toKey(params.startDate ?? null),
        endDate: toKey(params.endDate ?? null),
        city: params.city?.map((city) => city.name).join(",") ?? null,
        group_id: params.group_id ?? null,
        type: params.type?.join(",") ?? null,
        status: params.status?.join(",") ?? null,
        users: params.users?.map((user) => user.user?.id).join(",") ?? null,
        spaces: params.spaces?.map((space) => space.id).join(",") ?? null,
      },
    ] as const;
  },
};
